import { TOKEN } from '../contexts/authContext';
import { SIGNIN } from '../routes/paths';

export class ApiService {
    private readonly baseUrl?: string;

    constructor() {
        this.baseUrl = process.env.REACT_APP_URL_LOCAL;
    }

    async get<T>(path: string, params?: Record<string, any>): Promise<T> {
        return this.request<T>('GET', path, undefined, params);
    }

    async post<T>(
        path: string,
        data: any,
        params?: Record<string, any>,
        headers?: HeadersInit | undefined
    ): Promise<T> {
        return this.request<T>('POST', path, data, params, headers);
    }

    async patch<T>(path: string, data?: any): Promise<T> {
        return this.request<T>('PUT', path, data);
    }

    async delete(path: string): Promise<void> {
        return this.request<void>('DELETE', path);
    }

    private async request<T>(
        method: string,
        path: string,
        data?: any,
        params?: Record<string, any>,
        headers?: HeadersInit | undefined
    ): Promise<T> {
        let url = `${this.baseUrl}${path}`;

        if (params) {
            const urlFormater = new URL(url);
            Object.entries(params).forEach(([key, value]) => {
                if (typeof value === 'object') {
                    urlFormater.searchParams.append(key, JSON.stringify(value));
                } else {
                    urlFormater.searchParams.append(key, value);
                }
            });
            url = urlFormater.toString();
        }

        const isFormData =
            typeof FormData !== 'undefined' && data instanceof FormData;

        const response = await fetch(url, {
            method,
            headers: headers || {
                accept: '*/*',
                Authorization: `Bearer ${localStorage.getItem(TOKEN)}`,
                'Content-Type': 'application/json',
            },
            body: isFormData ? data : JSON.stringify(data),
        });

        if (!response.ok) {
            if (
                response.status === 401 &&
                window.location.pathname !== SIGNIN
            ) {
                // Redirect to login page
                localStorage.clear();
                window.location.href = SIGNIN;
            } else {
                console.error(
                    `Failed to ${method.toLowerCase()} data at ${url}`
                );
            }
        }

        return response.json() as Promise<T>;
    }
}

export const apiService = new ApiService();
